import {
  WcgToastConfig,
  WcgToastPanelSize,
  WcgToastBoxShadow,
} from '@wcg/frontend-framework';
import { ERM_ICONS_ENUM } from './dashboard.constant';

export const WCG_TOAST_CONFIG: Omit<WcgToastConfig, 'data'> = {
  duration: 5000,
  height: WcgToastPanelSize.XXLarge,
  width: WcgToastPanelSize.XXXLarge,
  toastType: 'success',
  panelClass: ['p-6!', 'gap-6!'],
  toastMessageClass: 'body-large mr-1!',
  iconPosition: 'front',
  horizontalPosition: 'end',
  boxShadow: WcgToastBoxShadow.XLarge,
};
